import React, { useRef } from 'react'
import Header from './Header';
import { BAG_SVG, INS_SVG, LIKE_SVG, COPY_SUCCESS } from '../staticTypes';
import { getFollow, postUserPoints, trackSharePop } from '../../Utils/blogs'


const Earn = (props) => {
	const { points, insShareUrl, facebookShareUrl, followFb, followIns } = props.data;
	const { onClick, launcherFlag , email, getReward, visitorId} = props;
	const followInsRef = useRef('')
	const followFbRef = useRef('')
	

	const followFaceBook = () => {
		const followFlag = followFbRef.current.getAttribute('_title')
		
		getFollow(email,followFlag)
		.then((res) => {
			if(res.code === 200){
				postUserPoints(email).then((res) => {
					getReward(res.result)
				}).catch((err) => {
					console.log(err)
				})
			}
		}).catch((err) => {
			console.log(err)
		})
		trackSharePop(visitorId, email, 'follow-facebook');
	}
	const followInstagram = () => {
		const followFlag = followInsRef.current.getAttribute('_title')
		
		getFollow(email,followFlag)
		.then((res) => {
			console.log(res);
			if(res.code === 200){
				postUserPoints(email).then((res) => {
					getReward(res.result)
				}).catch((err) => {
					console.log(err)
				})
			}
		}).catch((err) => {
			console.log(err)
		})
		trackSharePop(visitorId, email, 'follow-ins');
	}

	return (
		<div id="earn" className="earn-rewards">
			<Header points={points} onClick={onClick} launcherFlag={launcherFlag} link="/" />
			<div>
				<div className="panel-container with-join-program-footer">
					<div className="panel-subview">
						<div className="card-heading-container ">
							<div className="card-title heading ">Ways to earn</div>
						</div>
						<div className="card-list-container ">
							<div className="card-list-item-container ">
								<div className="card-list-item no-hover" aria-label="Place an order">
									<div className="card-list-item-content">
										{BAG_SVG}
										<div className="list-item-text-wrapper">
											<div className="list-item-title">Place an order</div>
											<div className="list-item-subtitle text-muted">3 Points for every $1 spent</div>
										</div>
									</div>
								</div>
							</div>
							<div className="card-list-item-container ">
								<div className="card-list-item no-hover" aria-label="Follow on Instagram">
									<div className="card-list-item-content">
										{INS_SVG}
										<div className="list-item-text-wrapper">
											<div className="list-item-title">Follow on Instagram</div>
											<div className="list-item-subtitle text-muted">50 Points</div>
										</div>
									</div>
									{
										points > -1 ?
											followIns === 'false' ?
												<a href={insShareUrl} target="_blank">
												<button 
													className="btn btn-sm btn-primary customer-points-products-button follow-earn" 
													style={{ padding: '10px 16px', width: 'auto', height: 'auto' }}
													onClick = { followInstagram }
													ref = { followInsRef }
													_title = 'ins'
													>
														Follow
													</button>
													</a>
												:
												<div className="check">
													{COPY_SUCCESS}
												</div>
											:
											''
									}



								</div>
							</div>
							<div className="card-list-item-container ">
								<div className="card-list-item no-hover" aria-label="Like on Facebook">
									<div className="card-list-item-content">
										{LIKE_SVG}
										<div className="list-item-text-wrapper">
											<div className="list-item-title">Like on Facebook</div>
											<div className="list-item-subtitle text-muted">50 Points</div>
										</div>
									</div>
									{

										points > -1 ?
											followFb === 'false' ?
												<a href={facebookShareUrl} target="_blank">
												<button 
													className="btn btn-sm btn-primary customer-points-products-button like-earn" 
													style={{ padding: '10px 16px', width: 'auto', height: 'auto' }}
													onClick = { followFaceBook }
													ref = {followFbRef}
													_title = 'facebook'
												>
													Like
												</button></a>
												:
												<div className="check">
													{COPY_SUCCESS}
												</div>
											:
											''
									}

								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

		</div>
	)
}

export default Earn;